export const TYPE = {
  LOCATION: 'location',
}
